exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._18cIZrB-cq3qi6Icyv93Ol{padding:8px}._2_Iiy7v9HgvREmFxzBjR_N{padding:16px}._1PGCoapd-csUpFgMEe8_-t{padding:24px}._3GnXISnflspGpXRNe_6OYG{padding:80px}._2C8qbW5NFmuIyaaNQR_zUb{padding:0 24px}._25HBIdFjNbSVevP41pPCrG{padding:24px 80px}._cSdCsbo4-AWtTAt2lKGG{margin:16px 0}._35ZayNHn7icDAtD_OD-Z9X{margin:16px 0 24px}", ""]);

// exports
exports.locals = {
	"grid-1": "8px",
	"grid-2": "16px",
	"grid-3": "24px",
	"grid-4": "32px",
	"grid-5": "40px",
	"grid-6": "48px",
	"grid-7": "56px",
	"grid-8": "64px",
	"grid-9": "72px",
	"grid-10": "80px",
	"xsm": "8px",
	"sm": "16px",
	"std": "24px",
	"lg": "80px",
	"pad_xsm": "_18cIZrB-cq3qi6Icyv93Ol",
	"pad_sm": "_2_Iiy7v9HgvREmFxzBjR_N",
	"pad_std": "_1PGCoapd-csUpFgMEe8_-t",
	"pad_lg": "_3GnXISnflspGpXRNe_6OYG",
	"pad_none_std": "_2C8qbW5NFmuIyaaNQR_zUb",
	"pad_std_lg": "_25HBIdFjNbSVevP41pPCrG",
	"mgn_sm_none": "_cSdCsbo4-AWtTAt2lKGG",
	"mgn_sm_none_std": "_35ZayNHn7icDAtD_OD-Z9X"
};


//////////////////
// WEBPACK FOOTER
// ./~/@chartbeat/light-side/~/css-loader?modules&importLoaders=1!./~/postcss-loader!./~/@chartbeat/light-side/lib/styles/spacing.cssm
// module id = 46
// module chunks = 0